<template>
  <div v-if="officeVisit" class="wl-office-visit-inherited">
    <h5 class="mb-2 text-primary">
      <i class="fas fa-clinic-medical mr-2"></i>
      From office visit #{{ officeVisit.id }}
    </h5>
    <p v-if="omaName" class="text-muted small mb-3">
      OMA: {{ omaName }}
      <span v-if="officeVisit.date_oma"> · {{ officeVisit.date_oma }}</span>
    </p>

    <b-row>
      <b-col cols="12" md="6" class="mb-3" v-if="vitals.length">
        <h6 class="font-weight-bold">Vital signs</h6>
        <ul class="list-unstyled mb-0">
          <li v-for="v in vitals" :key="v.id" class="mb-1">
            <b-badge variant="light" class="border text-dark mr-1">
              {{ v.prefix || v.name }}
            </b-badge>
            <span v-if="v.value != null && v.value !== ''">
              {{ v.value }}
              <small v-if="v.unit" class="text-muted">{{ v.unit }}</small>
            </span>
            <span v-else class="text-muted font-italic">No value</span>
          </li>
        </ul>
      </b-col>
      <b-col cols="12" md="6" class="mb-3" v-if="packageName">
        <h6 class="font-weight-bold">Package</h6>
        <b-badge variant="primary">{{ packageName }}</b-badge>
      </b-col>
    </b-row>

    <b-row>
      <template v-for="group in examGroups">
        <b-col
          v-if="group.items.length"
          :key="group.key"
          cols="12"
          md="6"
          class="mb-3">
          <h6 class="font-weight-bold">{{ group.label }}</h6>
          <ul class="list-unstyled mb-0">
            <li v-for="item in group.items" :key="group.key + '-' + item.id" class="mb-1">
              <b-badge variant="primary" class="text-white mr-1">{{ item.name }}</b-badge>
              <small v-if="item.price != null" class="text-muted">${{ item.price }}</small>
            </li>
          </ul>
        </b-col>
      </template>
    </b-row>
  </div>
  <div v-else class="text-muted small">
    No linked office visit data for this appointment.
  </div>
</template>

<script>
import { BRow, BCol, BBadge } from 'bootstrap-vue'

export default {
  name: 'WlOfficeVisitInherited',
  components: { BRow, BCol, BBadge },
  props: {
    officeVisit: {
      type: Object,
      default: null,
    },
  },
  computed: {
    omaName() {
      const o = this.officeVisit && this.officeVisit.omas
      if (!o) return ''
      return `${o.name || ''} ${o.lastname || ''}`.trim()
    },
    packageName() {
      const p = this.officeVisit && this.officeVisit.package
      return p && p.name ? p.name : ''
    },
    vitals() {
      const list = (this.officeVisit && this.officeVisit.type_vital_sign) || []
      return list.map(v => ({
        id: v.id,
        name: v.name,
        prefix: v.prefix,
        unit: v.unit,
        value: v.pivot ? v.pivot.value : null,
      }))
    },
    examGroups() {
      const ov = this.officeVisit || {}
      return [
        { key: 'procedures', label: 'Procedures', items: ov.procedures || [] },
        { key: 'laboratories', label: 'Laboratories', items: ov.laboratories || [] },
        { key: 'laboratories_pack', label: 'Lab packs', items: ov.laboratories_pack || [] },
        { key: 'tests', label: 'Tests', items: ov.tests || [] },
        { key: 'diagnostic_imagings', label: 'Diagnostic imaging', items: ov.diagnostic_imagings || [] },
        { key: 'treatments', label: 'Treatments', items: ov.treatments || [] },
      ]
    },
  },
}
</script>
